import {
	useState,
} from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {
	useAuthService,
} from 'services';
import {
	Input, Pattern,
} from 'components/form';
import Logo from 'components/logo';
import Button, {
	ButtonColor, ButtonType,
} from 'components/button';
import Typography, {
	TypographyType,
} from 'components/typography/karim/Typography';
import './LoginPage.scss';
import 'react-phone-input-2/lib/style.css'
import PhoneNumber from './PhoneNumber/PhoneNumber';
import Checkbox from 'components/checkbox/Checkbox';
import {
	UserSupport,
} from 'components/support/UserSupport';

const LoginPage = () => {
	const {
		getToken,
		getCodeForNumber,
		timeLeftForNewRequest,
		number, setNumber,
		isNumberValid, setIsNumberValid,
		verificationCode, setVerificationCode,
		isVerificationCodeValid, setIsVerificationCodeValid,
		isWaitingForVerification, setIsWaitingForVerification,
		isLoading,
		error,
	} = useAuthService();

	const [showAdvancedPhoneField, setShowAdvancedPhoneField] = useState(true);

	const buttonStyleOverride = {
		minWidth: '12rem',
	};

	const renderPhoneNumberInput = () => (
		<div className="center">
			<Typography
				className="mt-4 mb-4"
				type={TypographyType.subtitle}
				center
			>
				Legg inn ditt telefonnummer
			</Typography>
			{showAdvancedPhoneField ? (
				<PhoneNumber
					phoneNumber={number}
					onChange={setNumber}
					onValidation={setIsNumberValid}
				/>
			) : (
				<Input<string | undefined>
					rowValue={number}
					placeholderText="Telefonnummer"
					type="tel"
					onChange={setNumber}
					pattern={Pattern.Telephone}
					onValidation={valid => setIsNumberValid(valid)}
					onClear={() => {}}
					isPrivate
				/>
			)}
			<div className="checkbox-space">
				<Checkbox
					label="Egendefinert retningsnummer"
					onChange={(val) => setShowAdvancedPhoneField(!val)}
				>
					<Typography
						type={TypographyType.buttonSmall}
					>
						Egendefinert retningsnummer
					</Typography>
				</Checkbox>
			</div>
			<Row className="mt-4">
				<Col md={{
					span: 12,
				}}>
					<Button
						style={buttonStyleOverride}
						disabled={!isNumberValid || isLoading}
						type={ButtonType.SUBMIT}
					>
						Neste
					</Button>
				</Col>
			</Row>
			<Typography
				className="mt-4 mb-4"
				type={TypographyType.subtitle}
				center
			>
				<UserSupport phone="+4795129999" phoneText="+47 951 29 999"/>
			</Typography>
		</div>
	);

	const renderVerificationCodeInput = () => (
		<div className="center">
			<Typography
				className="mt-4 mb-4"
				type={TypographyType.subtitle}
				center
			>
				Legg inn den 6-sifrede koden mottatt på {number}
			</Typography>
			<Row>
				<Col>
					<Input< string | undefined>
						rowValue={verificationCode}
						placeholderText="Kode fra SMS"
						type="number"
						minLength={6}
						maxLength={6}
						onValidation={value => setIsVerificationCodeValid(value)}
						onChange={setVerificationCode}
						onClear={() => setVerificationCode('')}
						isPrivate
					/>
				</Col>
			</Row>

			<Row className="mt-4">
				<Col>
					<Button
						style={buttonStyleOverride}
						disabled={!isVerificationCodeValid || isLoading}
						type={ButtonType.SUBMIT}
					>
						Neste
					</Button>
				</Col>
			</Row>
			<Row>
				<Col>
					<Button
						style={{
							...buttonStyleOverride,
							color: 'black',
						}}
						color={ButtonColor.LINK}
						onClick={() => {
							setIsWaitingForVerification(false);
							setNumber('');
						}}
						disabled={!!timeLeftForNewRequest}
					>
						Jeg mottok ingen kode{timeLeftForNewRequest ? ` (${timeLeftForNewRequest})` : ''}
					</Button>
				</Col>
			</Row>
			<Typography
				className="mt-4 mb-4"
				type={TypographyType.subtitle}
				center
			>
				<UserSupport phone="+4795129999" phoneText="+47 951 29 999"/>
			</Typography>
		</div>
	);

	return (
		<Container className="login-page">
			<Row>
				<Col>
					<Logo size="5em"/>

					<Typography className="mt-4" type={TypographyType.headingsH1} center>
						TakeCargo
					</Typography>

					<Typography className="mt-4" type={TypographyType.headingsH3} center>
						Logg inn
					</Typography>


					<form onSubmit={(evt) => {
						evt.preventDefault();
						if (isWaitingForVerification) {
							getToken();
						}
						else {
							getCodeForNumber()
								.catch(console.error);
						}
					}}>
						{
							isWaitingForVerification ?
								renderVerificationCodeInput() : renderPhoneNumberInput()
						}
					</form>
				</Col>
			</Row>
		</Container>
	);
}

export default LoginPage;